import {  secondaryColor } from "utils/dashboardUtils";
import { useTranslation } from "react-i18next";

export const TimeAgoBadge = ({ date }) => {
  const { t } = useTranslation();
  const { label, color } = getTimeAgoWithColor(date, t);

  return (
    <div className="d-flex align-items-center gap-2">
      <span
        style={{
          width: "8px",
          height: "8px",
          borderRadius: "50%",
          backgroundColor: color,
          display: "inline-block",
        }}
      />
      <span style={{ fontSize: "12px",whiteSpace:"nowrap", color: secondaryColor }}>{label}</span>
    </div>
  );
};
function getTimeAgoWithColor(dateTime, t) {
  if (!dateTime) return { label: "", color: "#ccc" };

  const now = new Date();
  const past = new Date(dateTime);
  const diffInSeconds = Math.floor((now - past) / 1000);

  if (diffInSeconds < 60) {
    return { label: t("Just now"), color: "#22c55e" }; // green
  }

  const diffInMinutes = Math.floor(diffInSeconds / 60);
  if (diffInMinutes < 60) {
    return {
      label: t("{{count}} min ago", { count: diffInMinutes }),
      color: "#84cc16", // light green
    };
  }

  const diffInHours = Math.floor(diffInMinutes / 60);
  if (diffInHours < 24) {
    return {
      label: t("{{count}} hour ago", { count: diffInHours }),
      color: "#f59e0b", // yellow/orange
    };
  }

  const diffInDays = Math.floor(diffInHours / 24);
  return {
    label: t("{{count}} day ago", { count: diffInDays }),
    color: "#9ca3af", // gray
  };
}
